import { getters } from '/@/modules/core/app/helpers/store';

export const HasUnseenAnnouncementsMixin = {
  computed: {
    unseenAnnouncements() {
      return getters.announcement.getUnseenAnnouncements();
    }
  }
};
